import React from "react";

import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

import { LINKS } from "../../constants";
import { StackFooter, TypographyButton } from "./styles";

export const PublicFooter = () => {
  const { t: translate } = useTranslation();

  return (
    <StackFooter direction="row" spacing={1}>
      <Typography
        color="#98A2B3"
        fontSize="12px"
        fontWeight={500}
        fontFamily="Manrope"
        aria-label="title"
      >
        {translate("shipeezi")}
      </Typography>
      <TypographyButton
        color="#98A2B3"
        fontSize="12px"
        fontWeight={500}
        fontFamily="Manrope"
        data-cy="redirectContactForm"
        onClick={() => window.open(LINKS.contact, "_blank")}
      >
        {translate("contact")}
      </TypographyButton>
      <TypographyButton
        color="#98A2B3"
        fontSize="12px"
        fontWeight={500}
        fontFamily="Manrope"
        data-cy="redirectToTermsOfUse"
        onClick={() => window.open(LINKS.termsOfUse, "_blank")}
      >
        {translate("termsOfUse")}
      </TypographyButton>
      <TypographyButton
        color="#98A2B3"
        fontSize="12px"
        fontWeight={500}
        fontFamily="Manrope"
        data-cy="redirectToPrivacyPolicy"
        onClick={() => window.open(LINKS.privacyPolicy, "_blank")}
      >
        {translate("privacyPolicy")}
      </TypographyButton>
    </StackFooter>
  );
};
